import { useState, useEffect } from "react"
import { options, filterOptions } from "./options"

const getOption = (roleType, selectedType) => {
  if (roleType) {
    const selectedOption = options.find(
      (option) => option.role === roleType && option.id === selectedType,
    )
    return selectedOption || options.find((o) => o.role === roleType) || options[0]
  }
  const selectedOption = filterOptions.find(
    (option) => option.id === selectedType,
  )
  return selectedOption || filterOptions[0]
}
const useOption = (roleType, selectedType) => {
  const [option, setOption] = useState(getOption(roleType, selectedType))
  useEffect(() => {
    setOption(getOption(roleType, selectedType))
  }, [roleType, selectedType])
  return [option, setOption]
}
export default useOption
